export const ENTERPRISE_SITE_KEY_V2 =
  '6Ld0J8IcAAAAANyrnxzrRlX1xrrdXsOmsepUYosy';
export const ENTERPRISE_SITE_KEY_V3 =
  '6LdoPaUfAAAAAJphvHoUoOob7mx0KDlXyXlgrx5v';
